import { create } from 'zustand';
export const useLanguageStore = create((set) => ({
    language: localStorage.getItem('koggelman_lang') || 'en',
    setLanguage: (language) => {
        localStorage.setItem('koggelman_lang', language);
        set({ language });
    },
}));
